"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_1 = require("react");
var Declarative_1 = require("../../utils/Declarative");
var DialogWidget_1 = require("./DialogWidget");
var DomWidgets_1 = require("./../DomWidgets");
var TabStyles_1 = require("../../styles/TabStyles");
var getStyles = function () {
    return ({
        Body: {
            outline: 'none',
            overflow: 'auto',
            WebkitOverflowScrolling: 'touch',
        }
    });
};
var DialogBody = /** @class */ (function (_super) {
    tslib_1.__extends(DialogBody, _super);
    function DialogBody() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Get the padding style of the body depending upon the dialog type and if the footer is being shown
    DialogBody.prototype.getPaddingStyle = function () {
        var style = {
            paddingTop: 0,
            paddingRight: TabStyles_1.TabStyles.Spacing.LargeSpace,
            paddingBottom: TabStyles_1.TabStyles.Spacing.LargeSpace,
            paddingLeft: TabStyles_1.TabStyles.Spacing.LargeSpace
        };
        switch (this.props.type) {
            case DialogWidget_1.DialogType.NormalWithTitleBar:
                style.paddingTop = TabStyles_1.TabStyles.Spacing.LargeSpace;
                break;
            case DialogWidget_1.DialogType.LightweightTitleBar:
                style.paddingLeft = TabStyles_1.TabStyles.Spacing.ExtraLargeSpace - TabStyles_1.TabStyles.Sizing.BorderWidth;
                style.paddingRight = style.paddingLeft;
                break;
            case DialogWidget_1.DialogType.Uber:
                style.paddingTop = TabStyles_1.TabStyles.Spacing.MediumSpace;
                break;
            default:
                break;
        }
        if (this.props.showFooter) {
            style.paddingBottom = 0;
        }
        return style;
    };
    DialogBody.prototype.render = function () {
        var styles = getStyles();
        var bodyStyle = tslib_1.__assign({}, styles.Body, this.getPaddingStyle(), this.props.dialogBodyStyle);
        return (react_1.createElement(DomWidgets_1.Block, { 'data-tb-test-id': Declarative_1.testId(this.props.testId, 'Body'), style: bodyStyle, id: Declarative_1.testId(this.props.testId, 'Body-Id') }, this.props.children));
    };
    return DialogBody;
}(React.Component));
exports.DialogBody = DialogBody;
//# sourceMappingURL=DialogBody.js.map